<template>
  <div class="page">
    <main class="card card-centered">
      <div class="kicker">Reparaturtool</div>
      <h1 class="title">R2</h1>
      <p class="subtitle">Bitte melden Sie sich mit Ihrem Intranet-Konto an, um fortzufahren.</p>
      <button class="btn-login" @click="onLogin" :disabled="busy">
        {{ busy ? 'Weiterleitung …' : 'Anmelden' }}
      </button>
      <div v-if="error" class="error">{{ error }}</div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { isAuthenticated, startLogin } from '../services/auth';

const router = useRouter();
const busy = ref(false);
const error = ref<string | null>(null);

onMounted(() => {
  if (isAuthenticated()) {
    router.replace({ name: 'dashboard' });
  }
});

async function onLogin() {
  busy.value = true;
  error.value = null;
  try {
    await startLogin();
  } catch (e) {
    busy.value = false;
    error.value = 'Anmeldung konnte nicht gestartet werden.';
    console.error(e);
  }
}
</script>
